
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';

/**
 * 资源协作（平台端 · 只读监管）
 * 菜单 route 对齐：/collaboration、/collaboration/artist-invite
 */
const collaborationRouter: RouteRecordRaw = {
  path: `${roterPre}/collaboration`,
  name: 'Collaboration',
  component: Layout,
  alwaysShow: true,
  meta: {
    title: '资源协作',
    icon: 'link',
  },
  children: [
    {
      path: 'artist-invite',
      name: 'CollaborationArtistInvite',
      meta: {
        title: '艺人合作监管',
        noCache: true,
      },
      component: () => import('@/views/_expand/collaboration/artist-invite/index.vue'),
    },
    {
      path: 'artist-invite/detail',
      name: 'CollaborationArtistInviteDetail',
      component: () => import('@/views/_expand/collaboration/artist-invite/detail.vue'),
      meta: {
        title: '合作单详情',
        noCache: true,
        activeMenu: `${roterPre}/collaboration/artist-invite`,
      },
      hidden: true,
    },
    {
      path: 'place',
      name: 'CollaborationVenueIntent',
      meta: {
        title: '场地合作监管',
        noCache: true,
      },
      component: () => import('@/views/_expand/collaboration/venue-intent/index.vue'),
    },
    {
      path: 'place/detail',
      name: 'CollaborationVenueIntentDetail',
      component: () => import('@/views/_expand/collaboration/venue-intent/detail.vue'),
      meta: {
        title: '场地意向详情',
        noCache: true,
        activeMenu: `${roterPre}/collaboration/place`,
      },
      hidden: true,
    },
    {
      path: 'rental-slot',
      name: 'CollaborationRentalSlot',
      meta: {
        title: '场地档期监管',
        noCache: true,
      },
      component: () => import('@/views/_expand/collaboration/rental-slot/index.vue'),
    },
    {
      path: 'rental-slot/detail',
      name: 'CollaborationRentalSlotDetail',
      component: () => import('@/views/_expand/collaboration/rental-slot/detail.vue'),
      meta: {
        title: '场地档期详情',
        noCache: true,
        activeMenu: `${roterPre}/collaboration/rental-slot`,
      },
      hidden: true,
    },
    {
      path: 'draft',
      redirect: `${roterPre}/collaboration/settlement`,
    },
    {
      path: 'draft/detail',
      redirect: `${roterPre}/collaboration/settlement`,
    },
    {
      path: 'settlement',
      name: 'CollaborationSettlement',
      meta: {
        title: '协作应付监管',
        noCache: true,
      },
      component: () => import('@/views/_expand/collaboration/settlement/index.vue'),
    },
    {
      path: 'settlement/detail',
      name: 'CollaborationSettlementDetail',
      component: () => import('@/views/_expand/collaboration/settlement/detail.vue'),
      meta: {
        title: '协作应付详情',
        noCache: true,
        activeMenu: `${roterPre}/collaboration/settlement`,
      },
      hidden: true,
    },
    {
      path: 'monthly-count',
      name: 'CollaborationMonthlyCount',
      meta: {
        title: '协作发起统计',
        noCache: true,
      },
      component: () => import('@/views/_expand/collaboration/monthly-count/index.vue'),
    },
    {
      path: 'settings',
      name: 'CollaborationSettings',
      meta: {
        title: '协作配置',
        noCache: true,
      },
      component: () => import('@/views/_expand/collaboration/settings/index.vue'),
    },
    {
      path: 'review',
      name: 'CollaborationReview',
      meta: {
        title: '协作评价监管',
        noCache: true,
      },
      component: () => import('@/views/_expand/collaboration/review/index.vue'),
    },
  ],
};

export default collaborationRouter;
